import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Математика. 10 класс",
        subject: "Особенности изучения темы «Тригонометрия»",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Особенности изучения темы «Тригонометрия»",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Буцко Елена Владимировна",
                grade: "научный сотрудник лаборатории математического общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>Выбор темы кейса обусловлен тем, что курс тригонометрии в основной школе обладает большой практической направленностью, требующей от обучающихся достаточного овладения базовыми понятиями, умения осуществлять различные преобразования выражений.</p>
                                <br>
                                <p>Изучение тригонометрических понятий сопряжено с некоторыми трудностями: высоким уровнем абстракции понятий, сложной логической структурой их определений, недостаточностью учебного времени, предназначенного для осмысления уровня сложности вопросов. Тригонометрия играет большую роль в ходе реализации межпредметных связей.</p>
                                </div>`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">Раздел «Тригонометрия» традиционно занимает центральное место в курсе «Алгебры и начал математического анализа» и представляет собой его целостный и самостоятельный раздел. </p>
                    <p style="text-indent: 2vw;">Тригонометрия обладает внутрипредметными связями, например, с методом координат, с другими разделами математики: математический анализ, геометрия, алгебра, а также и межпредметными связями, например,  с физикой, астрономией.</p>
                    <p style="text-indent: 2vw;">Тригонометрия обладает большой практической направленностью, позволяющей решать задачи практического характера, связанные с целым рядом наук: астрономией, геодезией, навигацией, механикой, физикой, техникой, артиллерией, авиацией, гидравликой, медициной и многих других. Решение таких задач требует от обучающихся овладения базовыми понятиями, умения осуществлять преобразования тригонометрических выражений, решать тригонометрические уравнения, строить графики и исследовать тригонометрические функции.</p>
                    <p style="text-indent: 2vw;">Как правило, ученики, выбравшие профессию, для получения которой необходимо поступление в ВУЗ или колледж и требуется вступительный экзамен по математике, в школе выбирают изучение математики на профильном уровне. Необходимо подчеркнуть, что школьники, выбравшие профессии, которые не требуют вступительного экзамена по математике и по этой причине изучают математику в старшей школе на базовом уровне, в дальнейшем в своей профессиональной деятельности будут использовать тригонометрию.  </p>
                    <p style="text-indent: 2vw;">Задания по тригонометрии являются неотъемлемой частью единого государственного экзамена.</p>
                    <p style="text-indent: 2vw;">Анализ результатов выполнения заданий на умения выполнять вычисления и преобразования в 2022 году показал, что средний процент их выполнения составил от 55,2 до 73. Задания по тригонометрии содержатся в номере 7.  Это говорит о том, что выпускники справляются с простейшими вычислениями с рациональными числами, а процент выполнения  заданий с тригонометрическими преобразованиями гораздо ниже по сравнению с другими заданиями. Таким образом, факты свидетельствует о недостаточно сформированных  навыках тригонометрических преобразований  у выпускников.</p>
                    <p style="text-indent: 2vw;">По мнению экспертов для достижения высокого уровня сформированности высокого уровня знаний по тригонометрии учителю необходимо реализовать системный методический подход при изучении раздела «Тригонометрия».</p>
                    <p style="text-indent: 2vw;">Содержание раздела «Тригонометрия» разделено на два этапа изучения. </p>
                    <p style="text-indent: 2vw;">На первом этапе в курсе «Алгебры и начал математического анализа» 10 класса вводится определение тригонометрических функций числового, даётся описание тригонометрической окружности, вводятся понятия аргумента, понятия синуса, косинуса, тангенса числового аргумента  и обратных  тригонометрических функций, вводятся основные тригонометрические формулы, рассматриваются преобразования тригонометрических выражений, тригонометрические уравнения и их применения неравенств к решению математи¬ческих задач и задач из различных областей науки и реальной жизни.</p>
                    <p style="text-indent: 2vw;">На втором этапе в курсе «Алгебры и начал математического анализа» 11 класса рассматриваются примеры тригонометрических неравенств, изучаются тригонометрические функции, их свойства и графики, их использование для решения уравнений, использование графиков тригонометрических функций для исследования процес¬сов и зависимостей, которые возникают при решении задач из других учебных предметов и реальной жизни, а также исследование тригонометрических функций с помощью производной.</p>
                    <p style="text-indent: 2vw;">Рассмотрим, какие особенности изучения тригонометрии встречаются на первом этапе.</p>
                    
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Алимов Ю.М. и др. Алгебра и начала математического анализа. 10-11 класс. Базовый и углублённый уровни. — Москва: Просвещение, 2021",
                "Бородуля И.Т. Тригонометрические уравнения и неравенства. — Москва: Просвещение, 1989",
                "Гельфанд И.М., Львовский С.М., Тоом А.Л. Тригонометрия. — Москва: МЦНМО, 2003",
                "Мерзляк  А.Г. и др. Алгебра и начала математического анализа. 10 класс. Базовый уровень. — Москва: Вентана-Граф, 2021",
                "Попов, Н. И., Марасанов, А. Н. Тригонометрия : учеб. пособие. — Йошкар_Ола : Мар.гос. университет, 2000",
                "Старова О. А. Тригонометрия. // Математика. Всё для учителя. — 2012. - № 4 (16)",
            ],
            historical: [
                "Концепция развития математического образования в Российской Федерации. – Распоряжение от 24 декабря 2013 г. № 2506-р. – [Электронный ресурс]. – Режим доступа: URL: http://static.government.ru/media/files/41d4b63b1dd474c16d7a.pdf   (дата обращения: 14.04.2023)",
                "Примерная рабочая программа среднего общего образования. Математика. Базовый уровень (для 10–11 классов образовательных организаций). – [Электронный ресурс]. – Режим доступа: URL: https://edsoo.ru/Primernaya_rabochaya_programma_srednego_obschego_obrazovaniya_predmeta_Matematika_.htm (дата обращения: 14.04.2023)",
            ],
            sites: [
                "Портал «Единое содержание общего образования». [Электронный ресурс]. – Режим доступа: https://edsoo.ru/ (дата обращения: 14.04.2023)",
                "Российская электронная школа. [Электронный ресурс]: режим доступа: https://resh.edu.ru/subject/51/10/" +
                "(дата обращения: 14.04.2023)",
                "Единая коллекция цифровых образовательных ресурсов. [Электронный ресурс]. – Режим доступа: http://school-collection.edu.ru/ (дата обращения: 14.04.2023)",
            ],
            filesToDownload: [
                {
                    link: "./files/mat1.pdf",
                    fileName: "Вклад Леонарда Эйлера в развитие тригонометрии"
                },
                {
                    link: "./files/mat2.pdf",
                    fileName: "Задания на применение основного тригонометрического тождества"
                },
                {
                    link: "./files/mat3.pdf",
                    fileName: "Задания с иррациональными координатами"
                },
                {
                    link: "./files/mat4.pdf",
                    fileName: "Примеры уравнений"
                },
                {
                    link: "./files/mat5.pdf",
                    fileName: "Справочные материалы"
                }
            ]
        }
    ],
};
